var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card fade-up stop-dragging",on:{"click":_vm.chooseCard}},[_c('img',{staticClass:"stop-dragging",attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }